import { Route } from '@angular/router';
import { AiAssistantFormV2Component } from '../components/ai-assistant-configuration/ai-assistant-form-v2/ai-assistant-form-v2.component';
import { AiCapabilitiesPageComponent } from '../components/ai-capabilities-page/ai-capabilities-page.component';
import { AiCapabilityFormPageComponent } from '../components/ai-capability-form-page/ai-capability-form-page.component';
import { assistantConfigurationV2Guard } from '../core/guards/assistant-configuration-v2.guard';
import { AiAssistantSummaryPageComponent } from '../components/ai-assistant-summary-page/ai-assistant-summary-page.component';
import { unsavedChangesGuardV2 } from '../core/services/unsaved-changes-guard-v2';
import { AiAssistantPageComponent } from '../index';

export const AI_ASSISTANT_ROUTES: Route[] = [
  {
    path: 'assistants',
    children: [
      {
        path: '',
        component: AiAssistantPageComponent,
      },
      {
        path: ':assistantId/edit',
        component: AiAssistantFormV2Component,
        canDeactivate: [unsavedChangesGuardV2],
      },
      {
        path: ':assistantId/edit-v2',
        redirectTo: ':assistantId/edit',
      },
      {
        // Declared last so the two-segment routes above can never be swallowed by this one.
        path: ':assistantId',
        component: AiAssistantSummaryPageComponent,
        canActivate: [assistantConfigurationV2Guard],
        canDeactivate: [unsavedChangesGuardV2],
      },
    ],
  },
  {
    path: 'capabilities',
    children: [
      {
        path: '',
        component: AiCapabilitiesPageComponent,
      },
      {
        path: 'create',
        component: AiCapabilityFormPageComponent,
        canDeactivate: [unsavedChangesGuardV2],
      },
      {
        path: ':namespace/:capabilityId/edit',
        component: AiCapabilityFormPageComponent,
        canDeactivate: [unsavedChangesGuardV2],
      },
    ],
  },
];
